var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"px-3 inline-flex text-sm leading-5 font-semibold rounded-full",class:_vm.classes},[_vm._v("\n    "+_vm._s(_vm._f("titleCase")(_vm.titleCasedLabel))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }